import Tools from '@/app-model/tools.js';

const tools = new Tools();
const BUILDING_STATUS_STYLE_MAPPING = {
  'Overdue': ['EF3225', 'far fa-times-circle', '', 'text-danger'],
  'Ongoing Tests': ['EFA525', 'far fa-hourglass markerIcon', 'fas fa-sync', 'text-warning'],
  'Testing Soon': ['0091CF', 'far fa-clock', '', 'text-info'],
  'Compliant': ['149847', 'far fa-check-circle', '', 'text-success'],
  'No AFSS': ['6D6D6D', 'far fa-question-circle', '', 'text-secondary'],
  'N/A': ['6D6D6D'],
};

export default class Building {
  static retrieveBuildingListRequest(data = {}) {
      return {
        section: 'emiot',
        method: 'GET',
        path: `api/user-buildings`,
        data
      };
  }

  fetchBuildingList ({store: $store, data = {}}) {
    return $store.dispatch('modernApiRequest', Building.retrieveBuildingListRequest(data));
  }

  loadBuildings({store: $store, extra}) {
    return this.fetchBuildingList({store: $store})
      .then(response => {
        switch (response.status) {
          case 200 :

            let buildings = [];
            for (let building of response.data.data) {
              if (!building.id) {
                continue;
              }
              this.setStatus(building, extra);
            }

            $store.commit('setState', {variable: 'buildings', value: response.data.data, saveToLocal: false});
            break;
        }
        return response;
      });
  }

  sortByField(data, field) {
    let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

    return data.sort((a, b) => {
      let aData, bData;
      aData = a[field] === null ? 0 : a[field];
      bData = b[field] === null ? 0 : b[field];
      return collator.compare(aData, bData);
    });
  }

  updateStoredBuilding ({store: $store}, buildingId, building) {
    let storedBuilding = $store.getters.building({buildingId});
    storedBuilding = Object.assign(storedBuilding, building, {
      fullAddress: this.fullAddress(building),
      search: this.searchText(building)
    });

    $store.commit('applyArrState', {variable: 'buildings', value: storedBuilding, saveToLocal: false, findIndex: (building) => building.id === buildingId});
  }

  fullAddress (building) {
    let arrAddress = [
      building.address,
      building.suburb,
      building.state,
      building.post_code
    ].map(el => el !== undefined && el !== null && el.toString().length ? el.toString() : '');
    return `${arrAddress[0]}, ${arrAddress[1]}, ${arrAddress[2]} ${arrAddress[3]}`.replace(/(^,\s+)|(,\s*$)/, '');
  }

  searchText (building) {
    let fullAddress = this.fullAddress(building);

    return `${building.name ? building.name : ''} ${fullAddress ? fullAddress : ''} ${building.strata_no ? building.strata_no : ''}`
      .replace(/\W/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  populateProcessTitle(testReportType, testQty, testQtyNoPassed) {
    testReportType = testReportType === '' ? 'test' : testReportType;
    testReportType = testReportType.toLowerCase();

    return testQtyNoPassed ? `${testQtyNoPassed} devices has not passed ${testReportType}` : `All devices passed ${testReportType}`;
  }

  setStatus(building, extra = {}) {

    let statusStyle,
      testReportType = building.test_report_type === null ? '' : `${building.test_report_type} Test`
        .toLowerCase()
        .replace(/_+/g, ' ')
        .replace(/\b(\w)/g, el => el.toUpperCase()),
      successRate = Math.round((building.test_qty - building.test_qty_no_passed) * 100 / building.test_qty),
      processTitle = this.populateProcessTitle(testReportType, building.test_qty, building.test_qty_no_passed),
      report = '';

    statusStyle = BUILDING_STATUS_STYLE_MAPPING[building.building_status];


    let {status_error = 0, status_warning = 0, status_ok = 0} = building;

    building = Object.assign(
      building,
      {
        testReportType,
        statusStyle,
        successRate,
        processTitle,
        fullAddress: this.fullAddress(building),
        search: this.searchText(building)
      },
      extra
    );
  }

  static retrieveBuildingRequest(buildingId, data = {}) {
    return {
      section: 'emiot',
      method: 'GET',
      path: `api/user-buildings/${buildingId}`,
      data
    };
  }

  fetchBuilding ({store: $store, buildingId, data = {}}) {
    return $store.dispatch('modernApiRequest', Building.retrieveBuildingRequest(buildingId, data));
  }

  static retrieveFetchBuildingRolesRequest(buildingId) {
    return {
      section: 'emiot',
      method: 'GET',
      path: `api/user-buildings/${buildingId}/building-roles`,
    };
  }

  fetchBuildingRoles ({store: $store, buildingId}) {
    return $store.dispatch('modernApiRequest', Building.retrieveFetchBuildingRolesRequest(buildingId));
  }

  formatBuildingRoles(buildingRoles) {
    for (let i = 0; i < buildingRoles.length; i++) {
      buildingRoles[i].display_name = tools.ucfirst(buildingRoles[i].display_name);
    }
  }
}